<div *ngIf='userData' [formGroup]='formGroup' class='SetSmsDetails'>
  <div class='SetSmsDetails-header'>
    <div class='row'>
      <div class='col col-12 text-left d-flex flex-row'>
        <div class='Breadcrumbs'>
          <div class='Breadcrumbs-items'>
            <a [routerLink]="['/messages']"
            >
              <mat-icon class='Breadcrumbs-icon back'
              >keyboard_backspace
              </mat-icon
              >
            </a
            >
            <a [routerLink]="['/messages']" class='Breadcrumbs-item'
            >Set Sms Details</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class='SetSmsDetails-body mt-5 p-5'>
      <div class="row">
        <div class="col col-12">
          <mat-checkbox class="mt-3" formControlName="send_sms"
          >Enable SMS notifications</mat-checkbox
          >
        </div>
      </div>
      <div class="row mt-3">
        <h5>Valid mobile phone number</h5>
      </div>
      <div class="row mt-3">
        <div class="col col-12">
          <ngx-intl-tel-input
            [cssClass]="'custom'"
            [onlyCountries]="[CountryISO.UnitedStates, CountryISO.Canada]"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [maxLength]="15"
            [phoneValidation]="true"
            [numberFormat]="PhoneNumberFormat.National"
            formControlName="mobile_phone"
          ></ngx-intl-tel-input>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col col-12">
          <p class="mb-0 font-weight-bolder">Supported events:</p>
          <p class=" font-weight-bolder">New message in your main inbox</p>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col col-6">
          <app-button [observeApi]="true" [text]="buttonProperties.text" [color]="buttonProperties.color" [style]="buttonProperties.style" [Click]="buttonProperties.onClick"></app-button>
        </div>
      </div>
    </div>
  </div>
</div>
